import React, { ReactElement, useContext } from 'react';

import AppContext from '../../context';
import { SentryBoundary } from '../../utils/SentryBoundary';

import styles from './BonusPointsBanner.module.scss';
import getBonusPoints from './BonusPointsWrapper';

export default function BonusPointsBanner(): ReactElement {
    const { isNextJS, domain } = useContext(AppContext);

    const BonusPointsBox = React.useMemo(() => getBonusPoints(isNextJS), []);

    return (
        <SentryBoundary>
            <li className={styles.bpWrapper}>
                <BonusPointsBox siteDomain={domain} location="shop-header" />
            </li>
        </SentryBoundary>
    );
}
